import { combineReducers } from "redux";

// Import reducers
import authReducer from "./authReducer";
import alertReducer from "./alertReducer";
import adminReducer from "./adminReducer";
import superAdminReducer from "./superAdminReducer";
import customizeReducer from "./customizeReducer";
import achievementReducer from "./gamification/achievementReducer";
import referralReducer from "./gamification/referralReducer";

// Define the RootState interface
export interface RootState {
  auth: ReturnType<typeof authReducer>;
  alert: ReturnType<typeof alertReducer>;
  admin: ReturnType<typeof adminReducer>;
  superAdmin: ReturnType<typeof superAdminReducer>;
  customize: ReturnType<typeof customizeReducer>;
  achievement: ReturnType<typeof achievementReducer>;
  referral: ReturnType<typeof referralReducer>;
}

const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  admin: adminReducer,
  superAdmin: superAdminReducer,
  customize: customizeReducer,
  achievement: achievementReducer,
  referral: referralReducer,
});

export default rootReducer;
